import { BaseModel } from './base-model'

export type IMO = number | null

export abstract class VoyageImoModelBase extends BaseModel {
    abstract get imo(): IMO
    abstract set imo(imo: IMO)
    abstract get offlineSync(): any 
    abstract set offlineSync(data: any)
    abstract intialiseImo(): void
    abstract dispatchMissingImoEvent(): void
    abstract dispatchUnauthorizedImoEvent(): void
    abstract sendHeartBeat(): Promise<void>
}

let VoyageImoModel: VoyageImoModelBase | null = null

export function setVoyageImoModel(model: VoyageImoModelBase) {
    VoyageImoModel = model
}

export { VoyageImoModel }